import {
  FETCH_EMPLOYEES,
  ADD_NEW_EMPLOYEE,
  UPDATE_EMPLOYEE,
  START_LOADING,
  END_LOADING,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  employees: [],
};

const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_EMPLOYEES:
      return { ...state, employees: action.payload };
    case ADD_NEW_EMPLOYEE:
      return { ...state, employees: [...state.employees, action.payload] };
    case UPDATE_EMPLOYEE:
      return {
        ...state,
        employees: state.employees.map((emp) =>
          emp._id === action.payload._id ? action.payload : emp
        ),
      };
    default:
      return state;
  }
};

export default employeesReducer;
